export const HEADER_SIZE = "10vh";
